import axios from '@/plugins/axios';
import * as GmapVue from 'gmap-vue';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import VueClipboard from 'vue-clipboard2';
import App from './App.vue';
import i18n from './lang';
import CountryNamePlugin from './plugins/countryNamePlugin';
import vuetify from './plugins/vuetify';
import './registerServiceWorker';
import router from './router';
import store from './store';

Vue.use(VueAxios, axios);

Vue.use(CountryNamePlugin);
Vue.use(VueClipboard);

// This app does not require user geolocation; force-disable it to avoid
// browser permission prompts and inconsistent behavior on mobile.
if (typeof navigator !== 'undefined' && navigator.geolocation) {
    const deny = (errorCb) => {
        if (typeof errorCb === 'function') {
            errorCb({
                code: 1,
                message: 'Geolocation disabled by application',
                PERMISSION_DENIED: 1,
                POSITION_UNAVAILABLE: 2,
                TIMEOUT: 3,
            });
        }
    };
    try {
        navigator.geolocation.getCurrentPosition = (_success, error) => deny(error);
        navigator.geolocation.watchPosition = (_success, error) => {
            deny(error);
            return -1;
        };
    } catch (_e) {
        // Ignore if the runtime does not allow overriding geolocation methods.
    }
}

Vue.use(GmapVue, {
    load: {
        key: process.env.VUE_APP_API_KEY,
        // Geometry library is required for distance calculations (scoring).
        libraries: 'geometry',
        language: 'fr',
        // Avoid pinning to retired versions.
        v: 'weekly',
    },
});
Vue.config.productionTip = false;

const updateSizes = (obj = {}) => {
    obj.width = window.innerWidth;
    obj.height = window.innerHeight;
    document.documentElement.style.setProperty(
        '--global-height',
        window.innerHeight + 'px'
    );
    return obj;
};

Object.defineProperty(Vue.prototype, '$viewport', {
    value: Vue.observable(updateSizes()),
});

window.addEventListener('resize', () => {
    updateSizes(Vue.prototype.$viewport);
});

new Vue({
    vuetify: vuetify(i18n),
    router,
    i18n,
    store,
    axios,
    render: (h) => h(App),
}).$mount('#app');
